import React from "react";
import "../../styles/TermsOfUse.css"; // Import global styling
import { Link } from "react-router-dom";

function TermsOfUse() {
  return (
    <div className="page-container">
      <div className="content-wrap">
        <div className="terms-container">
          <h1>Terms Of Use</h1>
          <p>
            AGREEMENT BETWEEN USER AND Welcome to PuyVast
          </p>
          <p>
            The Welcome to PuyVast Web Site is comprised of various Web pages operated by Welcome to PuyVast.
          </p>
          <p>
            The Welcome to PuyVast Web Site is offered to you conditioned on your acceptance without modification of the terms, conditions, and notices contained herein. Your use of the Welcome to PuyVast Web Site constitutes your agreement to all such terms, conditions, and notices.
          </p>
          <h2>MODIFICATION OF THESE TERMS OF USE</h2>
          <p>
            Welcome to PuyVast reserves the right to change the terms, conditions, and notices under which the Welcome to PuyVast Web Site is offered, including but not limited to the charges associated with the use of the Welcome to PuyVast Web Site.
          </p>
          <h2>LINKS TO THIRD PARTY SITES</h2>
          <p>
            The Welcome to PuyVast Web Site may contain links to other Web Sites ("Linked Sites"). The Linked Sites are not under the control of Welcome to PuyVast and Welcome to PuyVast is not responsible for the contents of any Linked Site.
          </p>
          <h2>NO UNLAWFUL OR PROHIBITED USE</h2>
          <p>
            As a condition of your use of the Welcome to PuyVast Web Site, you warrant to Welcome to PuyVast that you will not use the site for any purpose that is unlawful or prohibited by these terms.
          </p>
          <h2>LIABILITY DISCLAIMER</h2>
          <p>
            THE INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR AVAILABLE THROUGH THE Welcome to PuyVast WEB SITE MAY INCLUDE INACCURACIES OR TYPOGRAPHICAL ERRORS.
          </p>
          <h2>CONTACT INFORMATION</h2>
          <p>
            If you have any questions about these Terms of Use, please contact us at: <a href="mailto:sudhir@codeswork.com" className="email-link">sudhir@codeswork.com</a>
          </p>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-left">
            <p>CIN Number: U63030KA2022PTC161825</p>
            <p>
              <Link to="/privacy-statement" className="footer-link">Privacy Statement</Link> |
              <Link to="/terms-of-use" className="footer-link"> Terms Of Use</Link>
            </p>
          </div>
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd.</p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6, Harris Road, Benson Town,<br></br> Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default TermsOfUse;